import { createFileRoute } from "@tanstack/react-router";
import { NeuralApiPage } from "../features/neuralApi/NeuralApiPage";

// The Neural API under TANK Neural (Robby, 2026-11-03): usage and keys. Not nested in /neural,
// whose page is the chat.
export const Route = createFileRoute("/w/$ws/neural_/api")({
  component: NeuralApiPage,
});
